
import { Component ,Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { LeedsBeckettComponent } from '../leeds-beckett/leeds-beckett.component';
import moment from 'moment';

@Component({
  selector: 'app-please-note',
  templateUrl: './please-note.component.html',
  styleUrls: ['./please-note.component.scss']
})
export class PleaseNoteComponent {
  universityMap: { [key: string]: string } = {
    '4': 'openLeeds',
    '492': 'openLeedsTrinity',
    '56' : 'openKingstone',
    '53': 'openBirmingham',
    '118' : 'openManchester'
  };
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<PleaseNoteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }
  ngOnInit(): void {
   
  }

  onContinue() {
    let result = this.universityMap[this.data?.universityID];
    if (result) {
      this.dialogRef.close(result);
    }
  }
  close(val?: any) {
    this.dialogRef.close(val);
  }

}

